import { cn } from '@/lib/cn';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';

type SortableTableHeaderProps<Column extends string> = {
  label: string;
  column: Column;
  activeColumn: string;
  direction: 'asc' | 'desc';
  onSort: (column: Column) => void;
  className?: string;
};

export function SortableTableHeader<Column extends string>({
  label,
  column,
  activeColumn,
  direction,
  onSort,
  className,
}: SortableTableHeaderProps<Column>) {
  const active = activeColumn === column;

  return (
    <th className={cn('px-5 py-3 font-medium', className)}>
      <button
        type="button"
        onClick={() => onSort(column)}
        className={cn(
          'inline-flex items-center gap-1 rounded-md transition-colors',
          active ? 'text-manejai-forest' : 'text-manejai-bark/60 hover:text-manejai-forest',
        )}
        aria-sort={active ? (direction === 'asc' ? 'ascending' : 'descending') : 'none'}
      >
        <span>{label}</span>
        {active ? (
          direction === 'asc' ? (
            <ArrowUp className="h-3.5 w-3.5 shrink-0" aria-hidden />
          ) : (
            <ArrowDown className="h-3.5 w-3.5 shrink-0" aria-hidden />
          )
        ) : (
          <ArrowUpDown className="h-3.5 w-3.5 shrink-0 opacity-40" aria-hidden />
        )}
      </button>
    </th>
  );
}
